export const chipStyle = { padding: "4px 11px", lineHeight: "20px" };
export const headerStyle = {
  gap: "12px",
  boxShadow: "0px 8px 8px 0px #0000000D",
  paddingBottom: "18px",
  paddingLeft: "10px",
};
